import {
  CUSTOM_OPEN_RESTRICTED_ITEM_MODAL,
  RestrictedModalTypesEnum,
} from '../const';

import { RestrictedItemDetails } from '../RestrictedItemsModal';

export const getUserLang = () => {
  try {
    const urlLang = document
      .querySelector('input[name=lang]:checked')
      ?.getAttribute('id')
      ?.replace('flag-', '');
    const cache = localStorage.getItem('mage-cache-storage');
    const storage = JSON.parse(cache || '{}');
    return urlLang || storage?.lang?.locale || 'en';
  } catch (err) {
    console.log('cannot get getUserLang', err);
    return 'en';
  }
};

export const langsList = ['en', 'de', 'it', 'es', 'fr'];
const configLang =
  typeof ENVIRONMENT_REGION !== 'undefined' ? ENVIRONMENT_REGION : null;
export const isEuEnv = configLang === 'EU';
// TODO: refactor without type assertion, or add comment
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
export const cacheStorage = localStorage.getItem(
  'mage-cache-storage',
) as string;

// Fetch JSON file with language keys for Intl, if EU
export const getLocaleData = async () => {
  try {
    let locales = {};
    const urlLang = document
      .querySelector('input[name=lang]:checked')
      ?.getAttribute('id')
      ?.replace('flag-', '');
    const storage = JSON.parse(cacheStorage);
    const storageLang =
      storage?.lang?.locale || localStorage.getItem('language');
    const localeRaw = urlLang || storageLang;
    const locale = langsList.includes(localeRaw) ? localeRaw : 'en';
    if (isEuEnv) {
      await fetch(`/media/translations/${locale}.json`)
        .then((response) => response.json())
        .then((data) => (locales = data))
        .catch((error) => {
          console.error(error);
        });
    }
    return { currentLocale: locale, messages: locales };
  } catch (e) {
    console.log(e);
    return { currentLocale: 'en', messages: {} };
  }
};

export type OpenRestrictedItemModalParams = {
  product: {
    isUnavailable: boolean;
    isGeoRestricted: boolean;
    isProjectRestricted: boolean;
    entityId: string;
    imageUrl?: string;
    thumbnailImageUrl: string;
    sku: string;
    manufacturer: string;
    manufacturer_sku?: string[] | string;
    isGpsCompliant?: boolean;
  };
  subtitle1: string;
  subtitle2: string;
  projectId: string | number;
};

export const openRestrictedItemModal = ({
  product,
  subtitle1,
  subtitle2,
  projectId,
}: OpenRestrictedItemModalParams): void => {
  let restrictionType: RestrictedModalTypesEnum =
    RestrictedModalTypesEnum.UNAVAILABLE;
  switch (true) {
    case product.isUnavailable: {
      restrictionType = RestrictedModalTypesEnum.UNAVAILABLE;
      break;
    }
    case product.isGeoRestricted: {
      restrictionType = RestrictedModalTypesEnum.GEO;
      break;
    }
    case product.isProjectRestricted: {
      restrictionType = RestrictedModalTypesEnum.PROJECT;
      break;
    }
  }

  const detail: RestrictedItemDetails = {
    title: product?.manufacturer,
    restrictionType,
    subtitle1: subtitle1,
    subtitle2: subtitle2,
    entityId: product.entityId,
    material: product,
    imgUrl: product?.imageUrl || product.thumbnailImageUrl,
    projectId: projectId,
  };

  // The project data is validated in the restricted item dialog
  window.dispatchEvent(
    new CustomEvent(CUSTOM_OPEN_RESTRICTED_ITEM_MODAL, {
      detail,
    }),
  );
};
